/**
 * Theme exported to the provider
 * This is globally available in styled-components when interpolating a function like so:
 * ${(props) => props.theme}
 * Or using import { withTheme } from 'styled-components';
 */
import { Theme as stardustTheme } from '@tillersystems/stardust';

const Theme = {
  ...stardustTheme,
};

export default Theme;



// WEBPACK FOOTER //
// ./src/components/Theme/index.js